import { type TagSegment, type ValidationLookup } from "components/CC/UI/TagInput/tagInputTypes";
import {
    type DisplayLabelLookup,
    type StepLabelLookup,
    getTagPillColor,
    parseSegments,
} from "components/CC/UI/TagInput/tagInputUtils";
import React, { useMemo } from "react";

interface DisabledTagDisplayProps {
    value: string;
    placeholder: string;
    displayLabelLookup?: DisplayLabelLookup;
    stepLabelLookup?: StepLabelLookup;
    validationLookup?: ValidationLookup;
}

export const DisabledTagDisplay = ({
    value,
    placeholder,
    displayLabelLookup,
    stepLabelLookup,
    validationLookup,
}: DisabledTagDisplayProps): React.JSX.Element => {
    const segments = useMemo(
        () => parseSegments(value, displayLabelLookup, stepLabelLookup, validationLookup),
        [value, displayLabelLookup, stepLabelLookup, validationLookup]
    );
    const hasTag = segments.some((s) => s.type === "tag");

    return (
        <div className="flex items-center gap-2 px-3 py-1 rounded border border-gray-200 bg-gray-50 min-h-8">
            <div className="flex-1 min-w-0 flex flex-wrap items-center gap-1">
                {hasTag ? (
                    segments.map((segment, index) => {
                        if (segment.type === "text") {
                            return segment.value ? (
                                <span key={index} className="text-gray-600 text-xs">
                                    {segment.value}
                                </span>
                            ) : null;
                        }
                        return (
                            <span
                                key={index}
                                style={{ backgroundColor: getTagPillColor((segment as TagSegment).paramType) }}
                                className="inline-flex items-center px-2 py-0.5 rounded text-white text-xs"
                            >
                                {(segment as TagSegment).displayLabel}
                            </span>
                        );
                    })
                ) : (
                    <span className="text-gray-500 text-sm">{value || placeholder}</span>
                )}
            </div>
        </div>
    );
};
